(function () {
  function labelFilters(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.tjm-collection--has-filter').forEach(function (section) {
      var label = section.getAttribute('data-filter-label');
      if (!label) return;
      section.querySelectorAll('.mobile-facets__open-wrapper, .mobile-facets__heading').forEach(function (element) {
        element.setAttribute('aria-label', label);
      });
    });
  }

  function syncCount() {
    var source = document.getElementById('ProductCount');
    var target = document.getElementById('TjmCollectionCount');
    if (!source || !target) return;
    var text = source.textContent.replace(/\s+/g, ' ').trim();
    if (text) target.textContent = text;
  }

  function syncLoadMore(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.tjm-collection__footer').forEach(function (footer) {
      var button = footer.querySelector('[data-tjm-load-more]');
      var pagination = footer.querySelector('.tjm-collection__pagination');
      if (!button || !button.getAttribute('data-next-url')) return;
      button.hidden = false;
      if (pagination) pagination.hidden = true;
    });
  }

  function observeOnce(element, options, callback) {
    if (!element || element.getAttribute('data-tjm-bound') === 'true') return;
    element.setAttribute('data-tjm-bound', 'true');
    var observer = new MutationObserver(callback);
    observer.observe(element, options);
  }

  function bind(root) {
    var scope = root && root.querySelector ? root : document;
    labelFilters(scope);
    syncCount();
    syncLoadMore(scope);

    observeOnce(scope.querySelector('#main-collection-filters'), { childList: true, subtree: true }, function () {
      labelFilters(scope);
    });
    observeOnce(document.getElementById('ProductCount'), { childList: true, subtree: true, characterData: true }, syncCount);
    observeOnce(scope.querySelector('#ProductGridContainer'), { childList: true }, function () {
      syncLoadMore(scope);
    });
  }

  function loadNext(button) {
    var nextUrl = button.getAttribute('data-next-url');
    var sectionId = button.getAttribute('data-section-id');
    if (!nextUrl || !sectionId || button.getAttribute('aria-busy') === 'true') return;

    button.setAttribute('aria-busy', 'true');
    button.disabled = true;

    var url;
    try {
      url = new URL(nextUrl, window.location.origin);
    } catch (error) {
      window.location.assign(nextUrl);
      return;
    }
    url.searchParams.set('section_id', sectionId);

    fetch(url.toString(), { headers: { Accept: 'text/html' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Load failed');
        return response.text();
      })
      .then(function (html) {
        if (!button.isConnected) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var grid = document.getElementById('product-grid');
        var nextGrid = parsed.getElementById('product-grid');
        if (grid && nextGrid) {
          nextGrid.querySelectorAll('.tjm-collection__item').forEach(function (item) {
            grid.appendChild(document.importNode(item, true));
          });
        }
        var nextButton = parsed.querySelector('[data-tjm-load-more]');
        var upcoming = nextButton && nextButton.getAttribute('data-next-url');
        button.disabled = false;
        button.removeAttribute('aria-busy');
        if (upcoming) {
          button.setAttribute('data-next-url', upcoming);
        } else {
          button.hidden = true;
        }
      })
      .catch(function () {
        window.location.assign(nextUrl);
      });
  }

  if (!window.tjmCollectionClickBound) {
    window.tjmCollectionClickBound = true;
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-tjm-load-more]');
      if (!button) return;
      event.preventDefault();
      loadNext(button);
    });
    document.addEventListener('shopify:section:load', function (event) {
      bind(event.target);
    });
  }

  bind(document);
})();
